module.exports = __webpack_public_path__ + "static/media/SALLE_TELE.7e88f519.jpg";